<mat-dialog-content>
    <app-filter-card UnlimitedHeight MaxWidthHundertPercent #liFilter [Settings]="LiFilterSettings | async" [Values]="LiFilterValues$ | async" (ValuesChange)="LiFilterValues$.next($event)"></app-filter-card>
    <app-dave-list-card
        style="max-height: inherit; min-height: 80vh;"
        [Data]="dataSource"
        [DisplayedCollums]="DisplayedColumns$ | async"
        [TableHeaderCollumsMap]="Headers"
        [CustomHeaderCellTemplates]="{ConsolidatedDate: dateHeader, InvoiceNumber: numberHeader}"
        (EntryClicked$)="onEntryClicked($event.entry.Id)"
        [Selectable]="true"
        [Clickable]="true"
        [SelectedIndex]="0"
        [CustomHeaderTemplate]="searchHeader"
        [tableLayoutFixed]="true"
        [OnlyOneFooterCell]="true"
        [DefaultSortActive]="'ConsolidatedDate'"
        [DefaultSortDirection]="'desc'"
        #listCard
    >
        <mat-paginator
            listCardFooter
            [pageSize]="initialPageSize"
            [pageSizeOptions]="[initialPageSize, 100, 250]"
            aria-label="Seite auswählen">
        </mat-paginator>
    </app-dave-list-card>
</mat-dialog-content>
<ng-template #numberHeader> Nummer <app-hint-icon hint="Nummer des Dokuments, z.B.: Rechnungsnummer"></app-hint-icon></ng-template>
<ng-template #dateHeader> Datum <app-hint-icon hint="Datum des Dokuments, z.B.: Rechnungsdatum"></app-hint-icon></ng-template>
<mat-dialog-actions mat-dialog-actions>
    <button mat-dialog-close="" (click)="Close()" Inverted app-button Color="cancel" class="button">Schließen</button>
</mat-dialog-actions>
<ng-template #searchHeader>
    <!-- Header -->
    <h3 class="headline">Dokument auswählen s</h3>
    <h3 class="headline">Dokument auswählen</h3>
    <div class="header-buttons">
        <!-- Search-->
        <mat-form-field *ngIf="listCard.Expanded && searchVisible" (click)="$event.stopPropagation()">
            <input #searchInput matInput type="text" placeholder="Suche" [formControl]="searchForm" />
            <button class="clear-search" mat-icon-button *ngIf="searchForm.value" (click)="searchForm.setValue('')">
                <fa-icon icon="times"></fa-icon>
            </button>
        </mat-form-field>
        <button style="margin: auto 0 auto auto" *ngIf="listCard.Expanded" app-round-button (click)="$event.stopPropagation(); toggleSearch()" [matTooltip]="searchVisible ? 'abbrechen' : 'suchen'">
            <fa-icon [icon]="searchVisible ? 'times' : 'search'"></fa-icon>
        </button>
        <!-- Filter-->
        <button
            *ngIf="!searchVisible"
            app-round-button
            (click)="liFilter.Toggle(); $event.stopPropagation()"
            [matBadge]="FilterAmount$ | async"
            [matBadgeHidden]="!(FilterAmount$ | async)"
            matTooltip="Filter"
            [matBadgeOverlap]="true"
            class="mat-badge-more-overlay"
        >
            <fa-icon icon="filter"></fa-icon>
        </button>
    </div>
</ng-template>
